import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-social',
    templateUrl: './social.component.html',
    styleUrls: ['./social.component.scss'],
    imports: [RouterLink]
})
export class SocialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
